import styled from 'styled-components'
import { BannerComponent } from 'Pages/landings/newLandings/common/components'
import { media, Breakpoints, textStyled } from 'Pages/landings/newLandings/common/style'

export const Banner = styled(BannerComponent)`
	background-position: right;
	${media('padding-right: 48%;', Breakpoints.ms)};
	${media('padding-right: 40%;', Breakpoints.lx)};
	${media('padding-right: 50%;', Breakpoints.xl)};
`
export const TextBanner = styled.p`
	${media(textStyled('SBSansDisplay', 'semibold', '18px', '26px', 'grey', 800), Breakpoints.ms)};
	${media(textStyled('SBSansDisplay', 'semibold', '32px', '40px', 'grey', 800), Breakpoints.lx)};
	${media(textStyled('SBSansDisplay', 'semibold', '40px', '48px', 'grey', 800), Breakpoints.xl)};
`
export const TextTitle = styled.p`
	${textStyled('SBSansInterface', 'regular', '18px', '26px', 'grey', 600)};
`
